import { render, staticRenderFns } from "./RelatedKeywords.vue?vue&type=template&id=16510568&scoped=true&"
import script from "./RelatedKeywords.vue?vue&type=script&lang=js&"
export * from "./RelatedKeywords.vue?vue&type=script&lang=js&"
import style0 from "./RelatedKeywords.vue?vue&type=style&index=0&id=16510568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16510568",
  null
  
)

export default component.exports